import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m12 6.85-1.577-2.023C9.543 3.7 8.213 3 6.737 3 4.169 3 2 5.15 2 7.914c0 3.712 2.483 7.234 5.385 10.022A34.22 34.22 0 0 0 12 21.632a34.218 34.218 0 0 0 4.615-3.696C19.517 15.148 22 11.626 22 7.914 22 5.151 19.83 3 17.263 3c-1.476 0-2.807.7-3.686 1.827L12 6.851Zm-1.453-4.638A6.586 6.586 0 0 0 6.737 1C3.017 1 0 4.096 0 7.914 0 17.038 12 24 12 24s12-6.962 12-16.086C24 4.096 20.984 1 17.263 1a6.586 6.586 0 0 0-3.81 1.212A6.848 6.848 0 0 0 12 3.598a6.82 6.82 0 0 0-1.453-1.386Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconToggleHeartOff24 = createIcon(IconComponent);